import React, { useEffect, useState } from "react";
import { CookiesProvider, withCookies } from "react-cookie";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";
import CovidInfoBanner from "./CovidInfoBanner";
import ContestWidget from "./ContestWidget";

import "styles/style.scss";

const Layout = ({ children, cookies, className, lang }) => {
  const [cookieBaner, setCookieBaner] = useState("");
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const isAcceptedCoookie = !!cookies.get("ogrodSwiatelCookies");
    !isAcceptedCoookie && setCookieBaner(true);

    const isDismissed = cookies.get("covidInfoCookie");
    isDismissed && setDismissed(false);
  }, [cookies]);

  const acceptCookieBaner = () => {
    const promiseSetCookie = new Promise((resolve) =>
      resolve(cookies.set("ogrodSwiatelCookies", "active", { path: "/" }))
    );
    promiseSetCookie.then(() => {
      setCookieBaner(false);
    });
  };

  const dismissCovidInfo = () => {
    const promiseSetCookie = new Promise((resolve) =>
      resolve(cookies.set("covidInfoCookie", "active", { path: "/" }))
    );
    promiseSetCookie.then(() => {
      setDismissed(false);
    });
  };

  return (
    <CookiesProvider>
      <GoogleReCaptchaProvider reCaptchaKey="6LcVoAkdAAAAAPw9m8ZKOlr5V-og50uJYq7I9v4M">
        <Header lang={lang} dismissed={dismissed} newsletter />
        {cookieBaner && (
          <CookieBanner onClick={acceptCookieBaner} lang={lang} />
        )}
        {dismissed && <CovidInfoBanner onClick={dismissCovidInfo} />}
        <main className={className}>{children}</main>
        <Footer lang={lang} />
        {/* <ContestWidget /> */}
      </GoogleReCaptchaProvider>
    </CookiesProvider>
  );
};

export default withCookies(Layout);
